/**
 * Small, deterministic policy helpers for map render diagnostics.
 *
 * Rendering telemetry is intentionally sampled and only records slow commits;
 * normal map renders must not create a network event or add work to the hot
 * path. Keeping the thresholds here makes the policy unit-testable without
 * importing React Native or Sentry.
 */

export const MAP_RENDER_SAMPLE_RATE = 0.1
export const MAP_RENDER_SLOW_MS = 16
export const MAP_RENDER_REPORT_COOLDOWN_MS = 60_000

export function shouldSampleMapRender(
  random = Math.random(),
  sampleRate = MAP_RENDER_SAMPLE_RATE,
): boolean {
  return Number.isFinite(random) && random >= 0 && random < sampleRate
}

export function shouldReportMapRender(
  actualDurationMs: number,
  sampled: boolean,
  slowThresholdMs = MAP_RENDER_SLOW_MS,
): boolean {
  return sampled && Number.isFinite(actualDurationMs) && actualDurationMs >= slowThresholdMs
}
